export type HeadingNodeType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export type TextNodeType = HeadingNodeType | 'p';

export function lowerPriorityHeadingNodeType(headingNodeType: HeadingNodeType): HeadingNodeType {
  switch (headingNodeType) {
    case 'h1':
      return 'h2';
    case 'h2':
      return 'h3';
    case 'h3':
      return 'h4';
    case 'h4':
      return 'h5';
    default:
      return 'h6';
  }
}

export function lowerPriorityTextNodeType(textNodeType: TextNodeType): TextNodeType {
  if (textNodeType === 'p') return 'p';

  return lowerPriorityHeadingNodeType(textNodeType);
}
